import { CreateAuthorizedCommunicationMessage } from 'domain/usecases/surgical-pendency/create-authorized-communication-message'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteCreateAuthorizedCommunicationMessage
  implements CreateAuthorizedCommunicationMessage
{
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}

  create(
    params: CreateAuthorizedCommunicationMessage.Params
  ): Promise<CreateAuthorizedCommunicationMessage.Model> {
    return this.surgicalPendencyRepository.createAuthorizedCommunicationMessage(
      params
    )
  }
}
